// @index(d:!,!util,!markup): export { default as ${variable} } from ${relpath}
export { default as Label } from './Label'
// /index

// @index(d:!,!util,!markup): export type { Props as ${variable}Props } from ${relpath}
export type { Props as LabelProps } from './Label'
// /index

export * from './util'